import { RoutePaths } from '@interfaces/routePaths'
import { Base } from '@views/Files/Base'
import { BaseLayout } from '../BaseLayout'

export const FILES_PATHS = [
  {
    path: RoutePaths.FILES,
    element: <BaseLayout />,
    children: [
      {
        index: true,
        element: <Base />,
      },
    ],
  },
]
